import React, {Component} from 'react';
import {Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis} from 'recharts';
import LoadingSplash from "../../globalComponents/LoadingSplash";
import ThreadbreaksByMachineToolTips from "./ThreadbreaksByMachineToolTips";

class ThreadbreaksByMachineBarChart extends Component {

    static defaultProps = {
        legend: [],
    };

    static chartColors = ['#4BB2C5', '#EAA228', '#C5B47F', '#579575', '#839557', '#958C12', '#BC85AC', '#6476E5', '#D8B83F', '#FF5800', '#0085CC', '#B775A3', '#CDDF54'];

    constructor(props) {

        super(props);

        this.handleClick = this.handleClick.bind(this);

    }

    handleClick(data, index) {

        // console.debug('data', data, 'index', index);

        if (!data) return;

        if (this.props.handleClick) this.props.handleClick(data, index, this.props.data);

    }

    getChartColor(index) {

        const chartColors = ThreadbreaksByMachineBarChart.chartColors;
        const maxColors = chartColors.length;

        return chartColors[(index % maxColors)];

    }

    getLegendPayload() {

        let legend = this.props.legend;

        return legend.map(
            (data, index) => {
                return ({
                    value: data.label, color: this.getChartColor(index),
                });
            }
        );

    }

    getBars() {

        let legend = this.props.legend;

        return legend.map(
            (data, index) => {
                return <Bar key={'bar-' + index} yAxisId="left" dataKey={data.key} name={data.label} fill={this.getChartColor(index)}/>
            }
        );

    }

    render() {

        if (!this.props.data) return <LoadingSplash color={'#0e3043'}/>;

        const width = this.props.width ? this.props.width : 1200;
        const height = this.props.height ? this.props.height : 400;
        const labelX = this.props.labelX ? this.props.labelX : null;
        const labelY = this.props.label ? this.props.label : 'Threadbreaks';
        const legendPayload = this.getLegendPayload();
        const chartData = this.props.data;
        const bars = this.getBars();

        return (
            <BarChart onClick={this.handleClick} width={width} height={height} data={chartData}>
                <XAxis dataKey="label" label={labelX}/>
                <YAxis yAxisId="left" orientation="left" label={{value: labelY, angle: -90, position: 'insideLeft'}} stroke="#05548E" style={{color: '#05548E'}}/>

                <CartesianGrid strokeDasharray="3 3"/>

                <Tooltip content={<ThreadbreaksByMachineToolTips/>}/>

                <Legend verticalAlign="top" payload={legendPayload}/>

                {bars}
            </BarChart>
        );

    }

}

export default ThreadbreaksByMachineBarChart;